// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3Q3oL","errors":"Errors_errors__axa6C"};